import React, { useState } from "react";
import { Modal } from "antd";
import IntlAddForm from "./addForm";
import styles from "./index.modules.less";

const IntlAddModal = ({ open, onCreate, onCancel, initialValues, confirmLoading }) => {
  const [formInstance, setFormInstance] = useState();

  return (
    <Modal
      className={styles.intlAddModal}
      open={open}
      width={580}
      title="添加软件"
      okText="创建软件"
      cancelText="取消"
      okButtonProps={{ autoFocus: true, loading: confirmLoading }}
      onCancel={onCancel}
      destroyOnClose
      onOk={async () => {
        try {
          const values = await formInstance?.validateFields();
          onCreate(values);
        } catch (error) {
          console.log("intl AddModal validate failed:", error);
        }
      }}
    >
      <IntlAddForm
        initialValues={initialValues}
        onFormInstanceReady={(instance) => {
          setFormInstance(instance);
        }}
      />
    </Modal>
  );
};

export default IntlAddModal;
